import { buildUrl } from "../api/auth";

const API_SERVED_IMAGE_PREFIXES = ["/uploads/"];
export const DEFAULT_EVENT_IMAGE_URL = "/assets/events/image-unavailable.svg";

export const resolveEventImageUrl = (imageUrl, fallback = DEFAULT_EVENT_IMAGE_URL) => {
  const value = String(imageUrl || "").trim();
  if (!value) return fallback;

  if (API_SERVED_IMAGE_PREFIXES.some((prefix) => value.startsWith(prefix))) {
    return buildUrl(value);
  }

  return value;
};

export const handleEventImageError = (event, fallback = DEFAULT_EVENT_IMAGE_URL) => {
  const image = event?.currentTarget;
  if (!image || image.dataset.eventFallbackApplied === "true") return;

  image.dataset.eventFallbackApplied = "true";
  image.src = fallback;
};
